<div class="p-dialog-header">
    <div class="p-d-flex p-dialog-title">
      <i class="pi pi-warning p-mr-2" style="align-self: center;"></i>
      {{
        title === ""
          ? ("SigvLibrary.SystemNotification" | translate)
          : (title || "" | translate)
      }}
    </div>
    <div class="p-dialog-header-icons">
        <button
        type="button"
        tabindex="-1"
        class="p-dialog-header-icon p-dialog-header-close p-link p-ripple"
        (click)="close()"
        >
        <span class="p-dialog-header-close-icon pi pi-close"></span
        ><span class="p-ink"></span>
        </button>
    </div>
</div>
<div class="p-dialog-content">
    <div class="p-grid">
        <div class="p-col-12">
            <div
                *ngFor="let item of errors"
                class="dialog-format-error"
                style="border-bottom: 0;"
                [ngClass]="{ 'hide-accordion-content': hideAccordionContent }"
            >
                <!-- error description -->
                <ng-container *ngIf="onlyDescription; else colnum">
                    <p-accordion
                        [multiple]="false"
                        expandIcon="pi pi-fw pi-collapse-open"
                        collapseIcon="pi pi-fw pi-collapse-close"
                    >
                        <p-accordionTab
                            [header]="item.description"
                            [selected]="false"
                        >
                            {{ item.errorMessage }}
                        </p-accordionTab>
                    </p-accordion>
                </ng-container>
                <!-- colnum -->
                <ng-template #colnum>
                    <ng-container [ngSwitch]="getTypeof(item.errorMessage)">
                        <ng-container *ngSwitchCase="'string'">
                            <div class="p-d-flex p-jc-between dialog-format-error">
                                <label class="p-col text p-p-0 p-d-flex p-ai-center">
                                    {{ item.description }}
                                </label>
                                <label class="p-col p-error p-p-0 p-d-flex p-ai-center p-jc-end">
                                    {{ item.errorString }}
                                </label>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <!-- colnum in accordion -->
                            <p-accordion
                                [multiple]="false"
                                expandIcon="pi pi-fw pi-collapse-open"
                                collapseIcon="pi pi-fw pi-collapse-close"
                                class="p-header-content"
                            >
                                <p-accordionTab
                                    [header]="item.description"
                                >
                                    <div
                                        *ngFor="let col of item.errorArray"
                                        class="p-d-flex p-jc-between dialog-format-error"
                                    >
                                        <label class="p-col text p-p-0 p-d-flex p-ai-center">
                                            {{ col.description }}
                                        </label>
                                        <label class="p-col p-error p-p-0 p-d-flex p-ai-center p-jc-end">
                                            {{ col.errorMessage }}
                                        </label>
                                    </div>
                                </p-accordionTab>
                            </p-accordion>
                        </ng-container>
                    </ng-container>
                </ng-template>
            </div>
        </div>
    </div>
</div>
<div class="p-dialog-footer">
    <div class="p-d-flex p-jc-center">
        <div class="button pv-0 ph-0">
            <button
                pButton
                type="button"
                [label]="'SigvLibrary.Ok' | translate"
                class="p-content-button p-button-secondary"
                (click)="close()"
            ></button>
        </div>
    </div>
</div>
